import { render, staticRenderFns } from "./ServiceGroupBlock.vue?vue&type=template&id=9e375f72&scoped=true&"
import script from "./ServiceGroupBlock.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e375f72",
  null
  
)

export default component.exports